/* WEARTH ADD-TO-CART DOUBLE-CLICK GUARD */
(function() {
  if (typeof jQuery === 'undefined') return;
  var wearthCartLock = false;
  jQuery(document).on('click', '.AddToCart, [name="add"], button[type="submit"][data-add-to-cart], .product-form__submit', function(e) {
    /* Never lock nuclear sticky — it is type=button without name=add, but belt-and-braces */
    if (jQuery(this).is('[data-wearth-sticky-submit], .wearth-sticky-checkout__btn') || jQuery(this).closest('[data-wearth-sticky-bag]').length) {
      return;
    }
    if (wearthCartLock) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    wearthCartLock = true;
    var $btn = jQuery(this);
    var prevOpacity = $btn.css('opacity');
    $btn.attr('data-wearth-busy', '1').css('opacity', '0.65').css('pointer-events', 'none');

    function release() {
      wearthCartLock = false;
      $btn.removeAttr('data-wearth-busy').css('opacity', prevOpacity || '').css('pointer-events', '');
    }

    setTimeout(release, 2500);
    jQuery(document.body).one('afterCartLoad.ajaxCart cart:update cart:added', release);
  });
})();

/* WEARTH — Kill rendorStickyCart at prototype (VariantSelects), not window.
   theme.js calls this.rendorStickyCart() — window override does nothing. */
(function() {
  function killStickyCart() {
    try {
      var VS = customElements.get("variant-selects");
      if (VS && VS.prototype && typeof VS.prototype.rendorStickyCart === "function") {
        VS.prototype.rendorStickyCart = function() {};
      }
    } catch (e) {}
  }
  killStickyCart();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", killStickyCart);
  }
  document.addEventListener("shopify:section:load", killStickyCart);
})();
